<template>
  <div>
    <v-btn to="/profil/ny" class="mt-12" color="primary" dark large absolute top right fab>
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-row v-if="persons">
      <v-list class="pa-2">
        <div class="headline">Undervisere</div>
        <v-list-item
          v-for="profile in filterBy(
            activePersons,
            'HyUnJYaYxlfsROChGtvl',
            'function'
          )"
          :key="profile.id"
        >
          <v-avatar color="grey" size="36" class="mr-2">
            <v-img v-if="profile.photo" :src="profile.photo" :alt="profile.firstName" />
            <span
              v-else
              class="white--text subtitle"
            >{{ profile.firstName | initials }}{{ profile.lastName | initials }}</span>
          </v-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <router-link :to="`/profil/${profile.id}`">
                {{ profile.firstName }} {{ profile.middleName }}
                {{ profile.lastName }}
              </router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-badge :content="amount" :value="amount" color="grey" overlap offset-x="1">
          <div class="headline">Elever</div>
        </v-badge>
        <v-list-item
          v-for="profile in filterBy(
             activePersons,
            '7mzJwXQe4KnKOQ7Gqovb',
            'function'
          )"
          :key="profile.id"
        >
          <v-avatar color="grey" size="36" class="mr-2">
            <v-img v-if="profile.photo" :src="profile.photo" :alt="profile.firstName" />
            <span v-else class="white--text subtitle">
              {{ profile.firstName | initials
              }}{{ profile.lastName | initials }}
            </span>
          </v-avatar>
          <v-list-item-content>
            <v-list-item-title>
              <router-link :to="`/profil/${profile.id}`">
                {{ profile.firstName }} {{ profile.middleName }}
                {{ profile.lastName }}
              </router-link>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-row>

    <v-row v-else>
      <div>Ingen tilknyttede</div>
    </v-row>
  </div>
</template>

<script>
import Vue2Filters from "vue2-filters";
export default {
  mixins: [Vue2Filters.mixin],
  filters: {
    initials: function(value) {
      if (value) {
        let first = value.charAt(0).toUpperCase();
        return first;
      }
    }
  },
  methods: {},
  created() {
    this.$store.dispatch("GET_CLASSES");
    this.$store.dispatch("activePersons");
  },
  data() {
    return {};
  },
  computed: {
    amount() {
      if (this.activePersons) {
        var amount = this.activePersons.filter(function(person) {
          return person.function == "7mzJwXQe4KnKOQ7Gqovb";
        });

        return amount.length;
      } else {
        return null;
      }
    },
    classes() {
      return this.$store.state.classes;
    },
    activePersons: function() {
      if (!this.persons) {
        return null;
      }
      return this.persons.filter(function(p) {
        return p.active;
      });
    },
    persons() {
      let result = [];
      if (this.classData) {
        result = this.filterBy(
          this.$store.getters.getList,
          this.classData.id,
          "class"
        );
      }

      if (result.length == 0) {
        result = null;
      }
      return result;
    },
    /* persons() {
      return this.$store.getters.getList;
    }, */
    classData() {
      if (this.classes) {
        let hold = this.classes.find(obj => {
          return obj.slug === this.$route.params.id;
        });
        return hold;
      } else {
        return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
